module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.20.0@axios/index.js
// module id = 242
// module chunks = 38